import BannerRepository from "../BannerRepository"

export default class CompanyInPageBannerRepository extends BannerRepository {
    static schemaId = "company_banner"

    constructor() {
        super(CompanyInPageBannerRepository.schemaId)
    }
}
